import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListFolderTemplateRequest extends IBaseRequest {
    canBeRoot?:       boolean;
    contactType?:     string;
    folderType?:      string;
    treeHandle?:      string;
    fpaTypeCategory?: string;
}

export class ListFolderTemplateRequest extends BaseRequest implements IListFolderTemplateRequest {
    public canBeRoot?:       boolean;
    public contactType?:     string;
    public folderType?:      string;
    public treeHandle?:      string;
    public fpaTypeCategory?: string;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.canBeRoot       = otherOptions.canBeRoot;
        this.contactType     = otherOptions.contactType;
        this.folderType      = otherOptions.folderType;
        this.treeHandle      = otherOptions.treeHandle;
        this.fpaTypeCategory = otherOptions.fpaTypeCategory;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.canBeRoot, 'canBeRoot');
        parameters += this.makeNode(this.contactType, 'contactType');
        parameters += this.makeNode(this.folderType, 'folderType');
        parameters += this.makeNode(this.treeHandle, 'treeHandle');
        parameters += this.makeNode(this.fpaTypeCategory, 'fpaTypeCategory');
        
        return super.wrapperXml('ListFolderTemplate', parameters);
    }
}
